import { type Brand, make } from 'ts-brand';

import type { Address } from './address';

/** Shape of the {@link BillingDetails} model. */
export type BillingDetailsShape = Readonly<{

  /** First name. */
  firstName: string;

  /** Second name. */
  secondName: string;

  /** Location. */
  location: Address;
}>;

/** User billing details. */
export type BillingDetails = Brand<BillingDetailsShape, 'BillingDetails'>;

/** User billing details constructor. */
export const makeBillingDetails = make<BillingDetails>();
